import React from 'react';
import PropTypes from 'prop-types';
import KpiTable from '../../../commons/KpiTable';

const StudentChurnTable = (props) => (
  <KpiTable
    title="CHURN"
    description="The number represents the percentage of students who have studied in the month prior to the reference month but have not study in the reference month."
    loading={props.loading}
    values={props.values}
    currentHigherIsBetter={false}
    onSelect={props.onSelect}
    formatter={props.formatter}
    feedbackColorRender={props.feedbackColorRender}
    additionalColumns={[
      {
        label: 'Standard Deviation',
        path: 'currentStandardDeviation',
      },
      {
        label: 'Total of Registers',
        path: 'currentAmount',
      },
    ]}
  />
);

StudentChurnTable.propTypes = {
  onSelect: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  values: PropTypes.array.isRequired,
  formatter: PropTypes.func.isRequired,
  feedbackColorRender: PropTypes.func.isRequired,
};

export default StudentChurnTable;
